import React from 'react';
import {FormattedMessage} from 'react-intl';
import InputMask from 'react-input-mask';

const dateFormatDivStyle = {
    padding: '0 10px',
    color: '#bbb'
};

class InputText extends React.Component {

    render() {
        return (
            <div className="field">
                {
                    this.props.fieldLabel &&
                    <label htmlFor={this.props.id}>{this.props.fieldLabel}</label>
                }
                <div className="element">
                    <InputMask
                        mask={this.props.mask}
                        maskChar={this.props.maskChar}
                        id={this.props.id}
                        name={this.props.name}
                        value={this.props.value}
                        type={this.props.type}
                        autoFocus={this.props.autoFocus}
                        onChange={(e) => this.props.handleChange(e)}
                        maxLength={this.props.maxlength}
                        size={this.props.size}
                        placeholder={this.props.placeholder}
                        pattern={this.props.pattern}
                    />
                    {
                        this.props.fieldLabelSubText &&
                        <div style={dateFormatDivStyle}>{this.props.fieldLabelSubText}</div>
                    }
                    {(this.props.fieldError && this.props.fieldErrorMessage) &&
                    <p id="name-error" className="error"><FormattedMessage id={this.props.fieldErrorMessage}/></p>
                    }
                </div>
            </div>
        );
    }
}

export default InputText;
